var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col" },
    [
      _c("p", { staticClass: "step-caption ft-bld" }, [
        _vm._v("Select the type of row you want to create"),
      ]),
      _vm._v(" "),
      _c("SelectWrapper", {
        attrs: {
          "forced-one": "",
          item: "Automated row",
          caption:
            "Use a template to generate a row that displays a selection of content based on number of views, date added, score..",
          value: true,
        },
        on: {
          input: function ($event) {
            return _vm.rowTypeUpdate("auto")
          },
        },
      }),
      _vm._v(" "),
      _c("SelectWrapper", {
        attrs: {
          "forced-one": "",
          item: "Tag row",
          caption:
            "Generate a row by selecting one or multiple tags. Apply some rules to organize the order of content",
        },
        on: {
          input: function ($event) {
            return _vm.rowTypeUpdate("tag")
          },
        },
      }),
      _vm._v(" "),
      _c("SelectWrapper", {
        attrs: {
          "forced-one": "",
          item: "Manual row",
          caption:
            "Create a row and manually select the content you want to add inside with the content search tool",
        },
        on: {
          input: function ($event) {
            return _vm.rowTypeUpdate("manual")
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nxt-out" }, [
        _c(
          "div",
          {
            staticClass: "btn main txt-blk",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.switchStep("nxt")
              },
            },
          },
          [
            _c("span", { staticClass: "hvr" }),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [_vm._v("Continue")]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }